module.exports = __webpack_public_path__ + "img/damages_managers.0af714ee.svg";